export default __webpack_public_path__ + "c2dbe9c02246a865acc4f2cac43baa89.png";